import styled from 'styled-components'

export const AdjustZonesContainer = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const AdjustZonesWrapper = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
`
